import React, { useState } from "react";
import Navbar from "./navbar";
import Footer from "./footer";
import "../index.css";
import "../SourceReportDetails.css";

const BASE_URL = process.env.REACT_APP_DATA_FEEDER;
const token = window.sessionStorage.getItem("jwtToken");
sessionStorage.setItem("xApiKey", "securedBIdatafeederAPIkeyOne");

const apiMap = {
  table1: {
    header: "Data Feeder Main Collection",
    sections: [
      {
        subtitle: "Daily Sourcing",
        apis: [
          {
            name: "Source Daily Stock Price",
            endpoint: "/data/sourceDailyStockPrice",
            note: "It will source the Daily stock Prices of all symbols runs daily at 5pm",
          },
        ],
      },
      {
        subtitle: "Weekly Sourcing",
        apis: [
          {
            name: "Symbol Valuation Data",
            endpoint: "/data/sourceSymbolValuationData",
            note: "It Will update the symbol valuation data for same month, new entry for new month.",
          },
          {
            name: "Quarterly Fundamental Sourcing All",
            endpoint: "/data/quarterlyFundamentalStockData",
            note: "it will source all symbols Latest Quarterly Fundamental data.",
          },
        ],
      },
      {
        mainNote:
          "These dates and period adjustments in quarterly tables will be done automatically after sourcing. But if you found any discrepancy In quarterly tables Then hit this end point It will corrects all the dates and period of all quarterly tables.",
        subtitle: "Data Pruning-Quarterly",
        title: "Date and Period Adjustment",
        apis: [
          {
            name: "Quarterly Period and Date Adjustments",
            endpoint: "/data/adjustPeriodAndDatesQuarterlyTables",
            note: "corrects the businessDate and period of all quarterly data from all quarterly tables",
          },
        ],
      },
      {
        mainNote:
          "At first it will gives the count of duplicates entries in all quarterly tables. Then it will delete The actual Duplicate data present in all quarterly tables By keeping the latest data persisted And older duplicate data deleted.",
        subtitle: "Duplicates Checking and Removal",
        apis: [
          {
            name: "Checking Duplicates Quarterly Tables",
            endpoint: "/data/checkDuplicates-Quarterly-Tables",
            note: "Gets the count of duplicate data present in all Quarterly tables",
          },
          {
            name: "Delete Duplicates Quarterly Tables",
            endpoint: "/data/deleteDuplicates-Quarterly-Tables",
            note: "Deletes the duplicates from Quarterly tables by keeping the latest(id) data in all quarterly tables",
          },
        ],
      },
      {
        mainNote:
          "This endpoint will do calculations for Latest data in Quarterly tables. It does not do the industry and sector level calculations, For that you have to hit the industry and sector Calculations endpoint separately.",
        subtitle: "Calculations of Data-Quarterly",
        apis: [
          {
            name: "Quarterly Calculations All",
            endpoint: "/data/quarterlyFundamentalCalculations",
            note: "Calculations of opm, revenue and other fields. for latest quarterly data",
          },
        ],
      },
      {
        mainNote:
          "Hit this endpoints after quarterly calculations To get the industry and sector level calculations In quarterly tables, This endpoint will do All the calculations and persist for the latest last Quarter only. If you want the Sector and industry level calculation to be persisted according to the date range Please visit the Ad-Hoc sourcing page. ",
        subtitle: "Industry and Sector leader selection Quarterly",
        apis: [
          {
            name: "Sector Growth Latest",
            endpoint: "/calculateQuarterlySectorGrowthLatest",
            note: "Does calculations at sector level and store the latest quarters data in database",
          },
          {
            name: "Industry Market Share Latest",
            endpoint: "/calculateQuarterlyMarketShareLatest",
            note: "Does calculations at industry level and store the latest quarters data in database",
          },
        ],
      },
      {
        mainNote:
          "Every time you want to transfer quarterly tables to production use UPSERT-Quarterly Endpoint instead of Transfer, In Upsert we are using monthYear to transfer only required data It will update the existing data and Insert if the data is not present in production database. Transfer data quarterly endpoint blindly transfers the data not present in Production database.",
        subtitle: "Production Data Transfer-Quarterly",
        apis: [
          {
            name: "Upsert Quarterly tables by monthYear",
            endpoint:
              "/data/upsertQuarterlyTablestoProd-by-MonthYear/{monthYear}",
            note: "Upserts the Quarterly data of production tables for specific monthYear, in all Quarterly tables",
            needsMonthYear: true,
            showMonthYearColumn: true,
          },
          {
            name: "Transfer Data Quarterly Tables uat to Prod",
            endpoint: "/data/transferData-QuarterlyTables-uatToProd",
            note: "simply inserts the rows of Quarterly data not exist in prod in all Quarterly tables",
          },
        ],
      },
      {
        mainNote:
          "This sourcing requires continuous monitoring during sourcing, Because the API key subscription is Limited.",
        subtitle: "Monthly Sourcing",
        apis: [
          {
            name: "Indian API Sourcing",
            endpoint: "/data/symbolInfoIndianAPI",
            note: "Sources latest Quarterly and Yearly stockdata from IndianAPI for all symbols.",
          },
        ],
      },
    ],
  },

  table2: {
    header: "Technical Indecators calculation",
    mainNote:
      "It happens At the end of the month, Before hitting this technical indicator endpoint Make sure you have Sourced consistent data in monthlysage tables, The sourcing in monthly stage tables is done using the script from the server, The server sourcing needs Multiple sourcing cycles And the data Must be latest for all stocks. Same applies for indices tables but indices tables has very less data.",
    sections: [
      {
        apis: [
          {
            name: "CalculateTechnicalIndicators",
            endpoint: "/data/calculateTechnicalIndicators",
            note: "it calculates the technincal indicator, it must be run after the data sourcing in monthlyStage table from server",
          },
          {
            name: "copy into Stockdatamonthly",
            endpoint:
              "/data/insertStageToStockdataMonthly-byMonthYear/{monthYear}",
            note: "it will copy data from monthlyStage to monthly Table",
            needsMonthYear: true,
            showMonthYearColumn: true,
          },
          {
            name: "transfer to prod stage and monthly table",
            endpoint:
              "/data/transferStockdatamonthlyAndStockdatamonthlystageToPROD-byMonthYear/{monthYear}",
            note: "transfer data to Production for both monthly and monthlyStage tables",
            needsMonthYear: true,
            showMonthYearColumn: true,
          },
          {
            name: "transfer indices tables to prod",
            endpoint:
              "/data/transferIndicesTablesToPROD-byMonthYear/{monthYear}",
            note: "transfer indices tables data to Production",
            needsMonthYear: true,
            showMonthYearColumn: true,
          },
        ],
      },
    ],
  },

  table3: {
    header: "Monthly Transformation",
    mainNote:
      "This operation uses fundamental yearly and quarterly tables to insert data in fundamental monthly tables The first endpoint will insert the rows Monthly tables With some data And the second endpoint will add the update the rows With data.",
    sections: [
      {
        apis: [
          {
            name: "Yearly transformMonthlyFundamentalStockData-yearly",
            endpoint: "/data/transformMonthlyFundamentalStockData-yearly",
            note: "It must be run after technical indicator steps. inserts the data in fundamental financialRatiosMonthly and financialGrowthMonthly table and fills the data.",
          },
          {
            name: "Quartarly transformMonthlyFundamentalStockData-Quarterly",
            endpoint: "/data/transformMonthlyFundamentalStockData-Quarterly",
            note: "it fills the data in monthlyGrowth and monthlyRatios tables.",
          },
        ],
      },
    ],
  },

  table4: {
    header: "Production Data transfer monthly",
    mainNote:
      "These end points will transfer the data according to the monthYear passed in respective tables in production database. It will update the existing data and insert if the data is not present in production database.",
    sections: [
      {
        apis: [
          {
            name: "UPSERT SymbolValuatiom uat to prod",
            endpoint:
              "/data/upsert-symbolvaluationdata-byMonthYear/{monthYear}",
            note: "Updates and inserts the Valuation data in production Database for specific monthYear",
            needsMonthYear: true,
            showMonthYearColumn: true,
          },
          {
            name: "UPSERT stockfinancialratiosdatamonthly uat to prod",
            endpoint:
              "/data/upsert-stockfinancialratiosdatamonthly-byMonthYear/{monthYear}",
            note: "Updates and inserts the financialRatiosmonthly data in production Database for specific monthYear",
            needsMonthYear: true,
            showMonthYearColumn: true,
          },
          {
            name: "UPSERT stockfinancialgrowthmonthly uat to prod",
            endpoint:
              "/data/upsert-stockfinancialgrowthmonthly-byMonthYear/{monthYear}",
            note: "Updates and inserts the financialGrowthMonthly data in production Database for specific monthYear",
            needsMonthYear: true,
            showMonthYearColumn: true,
          },
        ],
      },
    ],
  },

  table5: {
    header: "Yearly Collection",
    sections: [
      {
        apis: [
          {
            name: "Source latest data for all yearly tables",
            endpoint: "/data/yearlyFundamentalStockData",
            note: "Sources the latest Yearly Fundamental data for yearly tables latest entries",
          },
        ],
      },
      {
        mainNote:
          "These dates and period adjustments in yearly tables will be done automatically after sourcing. But if you found any discrepancy In yearly tables Then hit this end point It will corrects all the dates and period of all yearly tables.",
        subtitle: "Data Pruning-Yearly",
        title: "Date and Period Adjustment",
        apis: [
          {
            name: "Yearly Date Adjustments",
            endpoint: "/data/adjustDatesYearlyTables",
            note: "adjusts the businessDate and period of all Yearly data in all yearly tables",
          },
        ],
      },
      {
        title: "Duplicates Checking and Removing",
        mainNote:
          "At first it will gives the count of duplicates entries in all yearly tables. Then it will delete The actual Duplicate data present in all yearly tables By keeping the latest data persisted And older duplicate data deleted.",
        apis: [
          {
            name: "Checking Duplicates Count Yearly Tables",
            endpoint: "/data/checkDuplicates-Yearly-Tables",
            note: "Gets the count of duplicate data present in all  Yearly Tables",
          },
          {
            name: "Delete Duplicates Yearly Tables",
            endpoint: "/data/deleteDuplicates-Yearly-Tables",
            note: "Deletes the duplicates from Yearly tables by keeping the latest(id) data in all quarterly tables ",
          },
        ],
      },
      {
        subtitle: "Calculation of Data-Yearly",
        mainNote:
          "This endpoint will do calculations for Latest data in Yearly tables. It also does the industry and sector level calculations for latest Yearly Data.",
        apis: [
          {
            name: "Yearly Calculations All :",
            endpoint: "/data/yearlyFundamentalCalculations",
            note: "Calculations for Yealry Fundamental latest data present in database",
          },
        ],
      },
      {
        subtitle: "Production Data Transfer-Yearly",
        mainNote:
          "Every time you want to transfer yearly tables to production use UPSERT-Quarterly Endpoint instead of Transfer, In Upsert we are using monthYear to transfer only required data It will update the existing data and Insert if the data is not present in production database. Transfer data yearly endpoint blindly transfers the data not present in Production database.",
        apis: [
          {
            name: "Upsert Yearly Tables by monthYear",
            endpoint: "/data/upsertYearlyTablestoProd-by-MonthYear/{monthYear}",
            note: "Upserts the Yearly data of production tables for specific monthYear(Mar20XX), in all Yearly tables",
            needsMonthYear: true,
            showMonthYearColumn: true,
          },
          {
            name: "Transfer Data Yearly Tables uat to Prod",
            endpoint: "/data/transferData-YearlyTables-uatToProd",
            note: "simply inserts the rows of Yearly data not exist in prod in all Yearly tables",
          },
        ],
      },
    ],
  },

  table6: {
    header: "Sourcing SplitStock technical indicator",
    mainNote:
      "Before sourcing for split stock make sure the regular stock sourcing is completed.",
    sections: [
      {
        apis: [
          {
            name: "source split stock technicalIndicator",
            endpoint: "/data/sourceTechnicalIndicatorForSplitStock",
            note: "Refreshes(deletes and insertes) the data in monthly and daily table of the symbol which announces the split.",
          },
        ],
      },
    ],
  },
};

const SourceReportDetails = () => {
  const [stockInputs, setStockInputs] = useState({});
  const [monthYearInputs, setMonthYearInputs] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [loadingApis, setLoadingApis] = useState({});

  const handleStockNameChange = (key, value) => {
    setStockInputs({ ...stockInputs, [key]: value });
  };

  const handleMonthYearChange = (key, value) => {
    setMonthYearInputs({ ...monthYearInputs, [key]: value });
  };

  const handleSourceClick = async (endpoint, indexKey) => {
    // Prevent double click
    if (loadingApis[indexKey]) return;

  setLoadingApis(prev => ({ ...prev, [indexKey]: true }));

  let url = `${BASE_URL}${endpoint}`;
  if (endpoint.includes("{monthYear}")) {
    url = url.replace("{monthYear}", monthYearInputs[indexKey] || "");
  }

  if (stockInputs[indexKey]) {
    url += `?stockName=${stockInputs[indexKey]}`;
  }

  const xApiKey = sessionStorage.getItem("xApiKey");
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 10000);

  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-API-KEY": xApiKey,
      },
      signal: controller.signal
    });

    // If we reach here, we got a response within 10 seconds
    clearTimeout(timeoutId);

    if (!response.ok) throw new Error("API call failed");

    const data = await response.text();
    setModalMessage("Response: " + data);
    setShowModal(true);

  } catch (error) {
    if (error.name === 'AbortError') {
      // This triggers if the response takes longer than 10 seconds
      setModalMessage("Request submitted : check Data Sourcing Status Report.");
    } else {
      setModalMessage("Error: " + error.message);
    }
    setShowModal(true);
  } finally {
    // Always clear the timeout and reset the button
    clearTimeout(timeoutId);
    setLoadingApis((prev) => ({
      ...prev,
      [indexKey]: false, 
    }));
  }
};

  const renderTable = (tableKey) => {
    const tableData = apiMap[tableKey];
    if (!tableData || !tableData.header) return null;

    const tableHasStock = tableData.sections.some((section) =>
      section.apis.some((api) => api.needsStock),
    );

    const tableHasMonthYear = tableData.sections.some((section) =>
      section.apis.some((api) => api.needsMonthYear),
    );

    return (
      <div className="container-fluid">
        <h3 className="fw-bold text-center mb-4">{tableData.header}</h3>
        {tableData.mainNote && (
          <div className="table-main-note">
            <strong>Note:</strong> {tableData.mainNote}
          </div>
        )}
        <div className="table-responsive mb-5">
          <table className="table custom-striped-table align-middle">
            <thead className="table-light">
              <tr>
                <th style={{ width: "2%" }}>ID</th>
                <th style={{ width: "45%" }}>Scheduler Name</th>
                {tableHasStock && <th style={{ width: "20%" }}>Stock Name</th>}
                {tableHasMonthYear && (
                  <th style={{ width: "5%" }} className="text-center">
                    MonthYear
                  </th>
                )}
                <th style={{ width: "15%", paddingLeft: "120px" }}>Action</th>
              </tr>
            </thead>

            <tbody>
              {tableData.sections.map((section, secIndex) => (
                <React.Fragment key={secIndex}>
                  {/* Section Title Row */}
                  {section.subtitle && (
                    <tr className="section-subtitle-row">
                      <td
                        colSpan={
                          2 +
                          (tableHasStock ? 1 : 0) +
                          (tableHasMonthYear ? 1 : 0) +
                          1
                        }
                      >
                        <span className="section-subtitle">
                          {section.subtitle}
                        </span>
                      </td>
                    </tr>
                  )}
                  {section.title && (
                    <tr className="table">
                      <td
                        colSpan={
                          2 +
                          (tableHasStock ? 1 : 0) +
                          (tableHasMonthYear ? 1 : 0) +
                          1
                        }
                      >
                        <strong>{section.title}</strong>
                      </td>
                    </tr>
                  )}
                  {section.mainNote && (
                    <tr className="section-main-note">
                      <td
                        colSpan={
                          2 +
                          (tableHasStock ? 1 : 0) +
                          (tableHasMonthYear ? 1 : 0) +
                          1
                        }
                      >
                        <div className="">
                          <strong>Note:</strong> {section.mainNote}
                        </div>
                      </td>
                    </tr>
                  )}

                  {section.apis.map((api, index) => {
                    const indexKey = `${tableKey}-${secIndex}-${index}`;

                    return (
                      <tr key={indexKey}>
                        <td>{index + 1}</td>
                        <td>
                          {api.name}
                          {api.note && (
                            <span className="info-tooltip">
                              i<span className="tooltip-text">{api.note}</span>
                            </span>
                          )}
                        </td>
                        {tableHasStock && (
                          <td>
                            {api.needsStock && (
                              <input
                                className="form-control"
                                value={stockInputs[indexKey] || ""}
                                onChange={(e) =>
                                  handleStockNameChange(
                                    indexKey,
                                    e.target.value,
                                  )
                                }
                              />
                            )}
                          </td>
                        )}

                        {tableHasMonthYear && (
                          <td>
                            {api.needsMonthYear && (
                              <input
                                className="form-control"
                                placeholder="MMMYYYY"
                                value={monthYearInputs[indexKey] || ""}
                                onChange={(e) =>
                                  handleMonthYearChange(
                                    indexKey,
                                    e.target.value,
                                  )
                                }
                              />
                            )}
                          </td>
                        )}

                        <td style={{ paddingLeft: "90px" }}>
                          <button
                            className="btn btn-primary"
                            disabled={loadingApis[indexKey]}
                            onClick={() =>
                              handleSourceClick(api.endpoint, indexKey)
                            }
                          >
                            {loadingApis[indexKey]
                              ? "Running..."
                              : "Source Data"}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="section-gap">
                    <td
                      colSpan={
                        2 +
                        (tableHasStock ? 1 : 0) +
                        (tableHasMonthYear ? 1 : 0) +
                        1
                      }
                    ></td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <div className="main-content" style={{ paddingTop: "50px" }}>
        {renderTable("table1")}
        {renderTable("table2")}
        {renderTable("table3")}
        {renderTable("table4")}
        {renderTable("table5")}
        {renderTable("table6")}
      </div>

      {showModal && (
        <div className="modal fade show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">API Response</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>{modalMessage}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default SourceReportDetails;
